import { useTariffType } from 'components/direct-sales/quote/hooks/useTariffType';
import { TARIFF_TYPES } from 'config/app-config';

import type { TProduct } from 'api/models/TProduct';

export const useTariffConfig = (product: TProduct) => {
  const tariffConfig = {
    [TARIFF_TYPES.FIXED]: {
      decoration: 'tariff-shield-lock'
    },
    [TARIFF_TYPES.TRACKER]: {
      decoration: 'tariff-magnifying-glass'
    },
    [TARIFF_TYPES.VARIABLE]: {
      decoration: 'tariff-stacked-graph'
    }
  };
  const { tariffType } = useTariffType(product);

  return tariffConfig[`${tariffType}`] || {};
};
